import {
  AWARD_TYPE_AGI,
  AWARD_TYPE_NEED,
  AWARD_TYPE_SAI,
  FLAT_AMOUNT,
  PERCENTAGE,
} from '../../../../aid-studio.constants';
import { CALCULATION_VARIANTS } from '../calculations-step.constants';
import type { CalculationVariant } from '../calculations-step.types';

/** Subset of a regime definition needed to derive the calculations page variant. */
export interface RegimeDefinitionLike {
  awardType?: string | null;
  calculatedBy?: string | null;
}

/**
 * Derives the calculations page variant from a regime definition:
 * - `AGI` / `SAI` award type -> `agiSai` (wins over `FLAT_AMOUNT` so the
 *   "Calculate new need" checkbox stays hidden whenever AGI/SAI is selected,
 *   per product spec — see ADO #35943).
 * - `FLAT_AMOUNT` calculatedBy -> `flat`
 * - `PERCENTAGE` + `NEED` -> `percentOfNeed`
 * - anything else (incl. missing regime) -> `percentOfNeed`
 */
export const resolveCalculationVariant = (
  regime: RegimeDefinitionLike | null | undefined
): CalculationVariant => {
  const awardType = regime?.awardType;
  const calculatedBy = regime?.calculatedBy;

  if (awardType === AWARD_TYPE_AGI || awardType === AWARD_TYPE_SAI) {
    return CALCULATION_VARIANTS.agiSai;
  }

  if (calculatedBy === FLAT_AMOUNT) {
    return CALCULATION_VARIANTS.flat;
  }

  if (calculatedBy === PERCENTAGE && awardType === AWARD_TYPE_NEED) {
    return CALCULATION_VARIANTS.percentOfNeed;
  }

  return CALCULATION_VARIANTS.percentOfNeed;
};
